module.exports = __webpack_public_path__ + "img/maj1.38b1152a.jpg";